const csvCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const pdfFromBase64 = (b64) => {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: "application/pdf" });
};

export const missingCsv = (rows) => {
  const lines = [["Business Name", "Street Address", "City", "State", "Zip Code", "Phone", "Reason"].map(csvCell).join(",")];
  rows.forEach((r) => lines.push([r.name, r.street ?? r.address, r.city, r.state, r.zip, r.phone, r.reason].map(csvCell).join(",")));
  return new Blob([lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
};
